$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
	// find parking form modal
	$('.ups-find-parking-modal-trigger a').on('click', function(e) {
		console.log('hello!');
		e.preventDefault();
		$('body').addClass('ups-find-parking-modal-active');
	});
	
	// click button to close modal
	$('.ups-modal-button-close').on('click', function(e) {
		e.preventDefault();
		if ($('body').hasClass('ups-find-parking-modal-active')) {
			$('body').removeClass('ups-find-parking-modal-active');
		}
	});
	
	// hit esc key to close modal
	$(document).on('keydown', function(e) {
		if ($('body').hasClass('ups-find-parking-modal-active') && e.keyCode == 27) {
			$('body').removeClass('ups-find-parking-modal-active');
		}
	});
	
	// count statistics up from zero
	if ($('.ups-statistics-group').length > 0) {
		$('.ups-statistics-group').each(function(index, group) {
			var statistics = $('.ups-statistic', group);
			$(statistics).each(function(index, statistic) {
				var target = $('.ups-statistic-number', statistic)[0];
				var end_number = $(target).attr('data-number');
				var prefix = $(target).attr('data-prefix');
				var suffix = $(target).attr('data-suffix');
				var options = {
					startVal: 0,
					decimalPlaces: 0,
					duration: 3,
					useGrouping: true,
					useEasing: false,
					prefix: prefix,
					suffix: suffix,
					enableScrollSpy: true,
					scrollSpyOnce: true
				};
				var counter = new CountUp(target, end_number, options);
			});
		});
	}
	
	// facilities cards slider 
	var facilities_cards_groups = $('.ups-facilities-cards-group');
	$(facilities_cards_groups).each(function(index, group) {
		var slider = $(group).flickity({
			cellAlign: 'center',
			pageDots: false,
			wrapAround: true
		});
	});
	
});